import { defineComponent, inject, Ref } from 'vue';
import GoToForgotPassword from './GoToForgotPassword.class';
import { IIncentiveV2Store } from '@/domain/dto/store.incentive-v2.interfaces';
import { setupComponent } from '@studyportals/vue-platform';

export default defineComponent({
	setup: () => {
		const store = inject<IIncentiveV2Store>('incentiveV2Store');
		const isForgotPassword = inject<Ref<boolean>>('isForgotPassword');
		if (!store || !isForgotPassword) {
			throw new Error('Store or isForgotPassword not provided');
		}
		const component = new GoToForgotPassword(store, isForgotPassword);
		return setupComponent(component);
	}
});
